import { ref } from "vue"
import axios from "axios"
import { toast } from "@/toast"

const createAccountPath = "/partner/customers/create_account"
const updateCompanyPath = "/partner/customer/company"
const createHierarchyPath = "/partner/hierarchies/create"
const createSubscriptionPath = "/partner/subscriptions/checkout_api"

const useCreateSubscriptionActions = (email, requires, userId, company, subdomain, selectedInstanceOnDev, region, plan, isNgoEduGov, reseller) => {
  const isLoading = ref(false)

  const proceedToCreate = async () => {
    try {
      isLoading.value = true

      if (requires.value) {
        if (requires.value === "hierarchy") {
          await createHierarchy(userId)
        }
        else {
          const action = requires.value === "auth0" ? "both" : "chargebee"
          const { data } = await createAuth0AndChargebeeAccount(action)
          userId.value = data.userId
          await createHierarchy()
        }
      }

      await Promise.all([updateCompany(), createSubscription()])
      toast.success("The subscription was created successfully.")
    }
    catch (e) {
      toast.error(e)
    }
    finally {
      isLoading.value = false
    }
  }

  const createAuth0AndChargebeeAccount = (requiredAccount) => {
    const body = {
      email: email.value,
      required_account: requiredAccount,
    }
    if (requiredAccount === "chargebee") {
      body.user_id = userId.value
    }

    return axios.post(createAccountPath, body)
  }

  const createHierarchy = () => {
    return axios.post(createHierarchyPath, {
      endCustomerId: userId.value,
      involvedResellerId: reseller.value?.id, // if there is no reseller, it will be removed on the fly
    })
  }

  const updateCompany = () => {
    return axios.put(updateCompanyPath, {
      customerId: userId.value,
      customerCompany: company.value,
    })
  }

  const createSubscription = () => {
    return axios.post(createSubscriptionPath, {
      plan: plan.value.id,
      endCustomer: userId.value,
      subdomain: subdomain.value,
      region: region.value.code,
      isNgoEduGov: isNgoEduGov.value,
      tester: !(selectedInstanceOnDev.value),
    })
  }

  return {
    proceedToCreate,
    isLoading,
  }
}

export {
  useCreateSubscriptionActions,
}
